import React from "react"

import { ProductDataProvider } from "./src/context/ProductDataContext"
import { UserProvider } from "./src/context/UserContext"
import { CartProvider } from "./src/context/CartContext"
import { ParticleEffectProvider } from "./src/components/particleEffects/ParticleEffectContext"

import "./src/normalize.css"
import "prismjs/themes/prism.css"
import "./src/style.css"

export const wrapRootElement = ({ element }) => (
  <ProductDataProvider>
    <UserProvider>
      <CartProvider>
        <ParticleEffectProvider>{element}</ParticleEffectProvider>
      </CartProvider>
    </UserProvider>
  </ProductDataProvider>
)

export const onClientEntry = () => {
  if (typeof window === "undefined") return
  if (window.location.host !== "theroyalkellys.com") return

  const consent = localStorage.getItem("cookieConsent")
  if (consent === "false") return
}

export const onInitialClientRender = () => {
  const consent = localStorage.getItem("cookieConsent")

  if (consent === "false") {
    // Prevent any tag activity
    window.dataLayer = []
    window.dataLayer.push = () => {}

    // Remove GTM script if it somehow exists
    const gtmScript = document.querySelector(
      'script[src*="googletagmanager.com/gtm.js"]',
    )
    gtmScript?.parentNode?.removeChild(gtmScript)

    // Disable gtag
    if (window.gtag) window.gtag = () => {}
    const gaScript = document.querySelector('script[src*="gtag/js"]')
    gaScript?.parentNode?.removeChild(gaScript)
  }

  // Lazy-load background images
  const lazyBackgrounds = document.querySelectorAll(".lazy-background")
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target
          const bg = el.getAttribute("data-bg")
          if (bg) {
            el.style.backgroundImage = `url(${bg})`
            el.classList.add("loaded")
            observer.unobserve(el)
          }
        }
      })
    },
    { rootMargin: "200px" },
  )

  lazyBackgrounds.forEach(el => observer.observe(el))
}

// export const onRenderBody = ({ setPostBodyComponents }) => {
//   setPostBodyComponents([
//     <script key="judge.me" src="https://cdn.judge.me/widget.js" async></script>
//   ])
// }
